import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box';
import '../Projects/Project.css';
import resume from '../../Assets/Devanshi-Resume.pdf';
import contact from '../../Assets/contact-gif1.gif';
import period from '../../Assets/period.svg';
import Navbar from "../Navbar";
import Footer from "../Footer";

function Contact() {
  return (
    <section>
      <Navbar />
      <Box className="filebox">
            <Row>
            <aside>
              <Col sm={1}>
                <Container className="strip" style={{ height: '100%' }}>
                
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '15s' }}>CONTACT.          CONTACT.          CONTACT.          CONTACT.          CONTACT.          CONTACT.          CONTACT.          CONTACT.          CONTACT.          
              </div>
              </div>
              </div>
                </Container>
              </Col>
              <Col sm={11} className="main-project-section" style={{ marginLeft: '70px' }}>
              <Container className="main-contact-cont" style={{justifyItems: 'center', position: 'relative', marginLeft:'6px'}} >
                <Row >
                <Col sm={5}>
                <h1 className="git" style={{float: 'left', fontFamily:'Changa', fontSize: '2.8em', color: 'white', verticalAlign: 'bottom', paddingTop: '235px', alignItems:'start', alignContent:'start', fontWeight: '400'}}>LET'S GET IN TOUCH<img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{ justifyItems: 'start', margin: '2px', paddingBottom: '3%', verticalAlign: 'bottom' }}
                    /></h1>
                    <p className="content contact-txt" style={{color: 'white', textAlign:'left'}}>Please feel free to contact me regarding potential collaborations or any other inquiries.</p>
                </Col>
                <Col sm={7}>
                <img 
                      src={contact}
                      alt="contact"
                      className="img-fluid contactimg"
                      style={{float: 'right', borderRadius:'20px', height: '400px', width: 'auto', paddingRight: '11px' }}
                    />
                </Col>
                {/* <img
                      src={contact}
                      alt="contact"
                      className="img-fluid"
                      style={{alignItems:'start', justifyItems: 'left', paddingLeft: '0px', marginLeft: '0px', marginLeft:'50px', paddingBottom: '16px', maxHeight: '350px', width: 'auto'}}
                    /> */}
                  </Row>
                  <Row className="details" style={{paddingBottom: "50px", alignContent: 'center', paddingRight: '100px', fontFamily: 'Changa', fontSize: '1.2em', position:'relative'}} >
                    <Col sm={3}  className="box-col">
                    <a className="links " href="mailto: devanshijhaveri2001@gmail.com"><div className="contact-box box-head" style={{border: "1px solid white", display: 'flex', justifyContent:'center', alignItems:'center', height: '100px', width: '250px' }}>
                    <p className="contact-box contact-head" style={{marginBottom: '0px'}}>EMAIL</p>
                    </div></a>
                    </Col>
                    <Col sm={3}  className="box-col">
                    <a className="links " rel="noopener noreferrer" target="_blank" href="https://www.linkedin.com/in/devanshi-jhaveri-aa548b1a4/"><div className="contact-box box-head" style={{border: "1px solid white", display: 'flex', justifyContent:'center', alignItems:'center', height: '100px', width: '250px' }}>
                    <p className="contact-box contact-head" style={{marginBottom: '0px'}}>LINKEDIN</p>
                    </div></a>
                    </Col>
                    <Col sm={3}  className="box-col">
                    <a className="links " rel="noopener noreferrer" target="_blank" href="https://www.behance.net/devanshijhaveri24"><div className="contact-box box-head" style={{border: "1px solid white", display: 'flex', justifyContent:'center', alignItems:'center', height: '100px', width: '250px' }}>
                    <p className="contact-box contact-head" style={{marginBottom: '0px'}}>BEHANCE</p>
                    </div></a>
                    </Col>
                    <Col sm={3}  className="box-col">
                    <a className="links " rel="noopener noreferrer" target="_blank" href={resume}><div className="contact-box box-head" style={{border: "1px solid white", display: 'flex', justifyContent:'center', alignItems:'center', height: '100px', width: '250px' }}>
                    <p className="contact-box contact-head" style={{marginBottom: '0px'}}>RESUME</p>
                    </div></a>
                    </Col>
                    
                  

                </Row>
                  {/* <a href={resume} download="Devanshi_Resume"><Button className="about-button resume-button"> Download Resume </Button></a>
                    <object className="resume"
                    data={resume}
                    width="1000"
                    height="800"
                    ></object> */}
        </Container>
              </Col>
              </aside>
            </Row>
            <Footer />
      </Box>
    </section>
  );
}

export default Contact;
